import { getRequest } from 'api';

export async function getUserData(dispatch) {
    try {
        dispatch({ type: 'REQUEST_DATA' });
        let response = await getRequest('/coach/info');
        const data = response.data;
        if (response.ok && data.name) {
            dispatch({ type: "GET_DATA_SUCCESS", payload: data });
            localStorage.setItem('userData', JSON.stringify(data));
        }
        return response;
    } catch (error) {
        dispatch({ type: "GET_DATA_ERROR", error: error })
    }
}

export function logOutUser(dispatch) {
    dispatch({ type: 'LOGOUT_USER' });
    localStorage.removeItem('userData');
    window.location.reload();
}